<div #accelaControlDiv [id]="this.getDivElementId()" class="textinput accelaControl" [formGroup]="this.controlRef.parent" >
    <input [formControlName]="this.controlData.name" [name]="this.controlData.name" [id]="this.controlData.name" type="password" [attr.aria-labelledby]="this.getLabelElementId()" [attr.aria-required]="this.controlData.required" [required]="this.controlData.required" [readOnly]="this.controlData.readOnly" 
         [attr.maxlength]="this.maxLength" [placeholder]="this.controlData.placeholder" 
         tooltipEvent="hover|focus" [accelaTooltip]="this.controlData.tooltip" [escape]="false" [appendTo]="accelaControlDiv" tooltipPosition="bottom"
          pPassword>
    <label [for]="this.getLabelElementId()" [id]="this.getLabelElementId()" [attr.data-required]="this.controlData.required">{{this.label}}</label>
</div>
<div *ngIf="!this.adminMode" class="validationFeedback">
    <small *ngIf="this.controlRef?.errors?.required && (this.controlRef?.touched || this.controlRef?.dirty)"
        class="ng-invalid p-invalid">
        {{this.getRequiredFieldValidationMsg()}}
    </small>
    <small *ngIf="this.controlRef?.errors?.mustMatch && (this.controlRef?.touched || this.controlRef?.dirty)"
        class="ng-invalid p-invalid" i18n="Password Confirmation does not match Password | Password Mismatch Validation Message">
        Password Confirmation does not match Password.
    </small>
    <small *ngIf="this.controlRef?.errors?.passwordReq && (this.controlRef?.touched || this.controlRef?.dirty)" class="ng-invalid p-invalid">
        {{this.controlRef?.errors?.passwordReq}}
    </small>

</div>    
